// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconIndicator_indicatorContainer__Hx7U0 {
  position: relative;
  width: 200px;
  height: 15px;
  margin: 0 auto;
  transition: height 0.3s ease;
}
.IconIndicator_indicatorContainer__Hx7U0:hover {
  height: 30px;
}
.IconIndicator_indicatorContainer__Hx7U0:focus {
  height: 60px;
  outline: none;
}
.IconIndicator_indicatorContainer__Hx7U0:focus-within {
  height: 60px;
}

@keyframes IconIndicator_fadeInWiggleAndColor__5jroi {
  from {
    opacity: 0;
    transform: translateX(1000%) rotate(90deg);
    filter: grayscale(100%); /* Start in full grayscale */
  }
  20% {
    transform: translateX(-1000%) rotate(-100deg);
  }
  40% {
    transform: translateX(500%) rotate(50deg);
    filter: grayscale(40%); /* Still in grayscale */
  }
  60% {
    transform: translateX(-500%) rotate(-50deg);
    filter: grayscale(60%); /* Still in grayscale */
  }
  80% {
    opacity: 0.8;
    transform: translateX(200%) rotate(29deg);
    filter: grayscale(80%); /* Still in grayscale */
  }
  95% {
    opacity: 0.95;
    transform: translateX(-100%) rotate(-1deg);
    filter: grayscale(0%); /* Begin shifting to full color */
  }
  to {
    opacity: 1;
    transform: translateX(0) rotate(0deg);
    filter: grayscale(0%); /* End in full color */
  }
}
.IconIndicator_line__s\\+aIY {
  position: absolute;
  top: 0;
  bottom: 0;
  border-right: 10px solid;
  transition: all 0.3s ease;
  z-index: 9999;
  opacity: 0;
  animation: IconIndicator_fadeInWiggleAndColor__5jroi 1.2s ease-in-out forwards;
}
.IconIndicator_line__s\\+aIY:hover, .IconIndicator_line__s\\+aIY:focus {
  transform: scale(2.1);
  cursor: pointer;
}
.IconIndicator_line__s\\+aIY:hover .IconIndicator_reasonMessage__rgF2\\+ {
  display: block;
}
.IconIndicator_line__s\\+aIY div {
  z-index: 9999;
}
.IconIndicator_line__s\\+aIY span {
  display: none;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 5px;
  background-color: #fff;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  margin-bottom: 5px;
}
.IconIndicator_line__s\\+aIY:hover span, .IconIndicator_line__s\\+aIY:focus span {
  display: block;
}

.IconIndicator_contactRange__rwVM2 {
  position: absolute;
  overflow: hidden;
  top: 0;
  bottom: 0;
  background-color: orange;
  z-index: 1;
}

.IconIndicator_contactTimestamp__NRVxo {
  border-right-color: rgba(139, 195, 74, 0.7);
}

.IconIndicator_minDays__x5l4L {
  border-right-color: rgba(145, 165, 39, 0.4);
}

.IconIndicator_maxDays__PEp1Q {
  border-right-color: rgba(244, 67, 54, 0.6);
}

.IconIndicator_presentDays__ZFeeP {
  border-right-color: rgba(255, 235, 59, 0.4);
}

.IconIndicator_message__69Qxm {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
}

.IconIndicator_contactRange__rwVM2 {
  transition: all 0.3s ease;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
.IconIndicator_contactRange__rwVM2:hover {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
  transform: translateY(-2px);
}

.IconIndicator_contactRange-0-15__ClGrG {
  background-color: rgba(139, 195, 74, 0.2);
}

.IconIndicator_contactRange-16-30__wTcDD {
  background-color: rgba(205, 220, 57, 0.2);
}

.IconIndicator_contactRange-31-45__oA\\+ZZ {
  background-color: rgba(255, 235, 59, 0.2);
}

.IconIndicator_contactRange-46-60__2QU7t {
  background-color: rgba(255, 193, 7, 0.2);
}

.IconIndicator_contactRange-61-75__mHIC5 {
  background-color: rgba(255, 152, 0, 0.2);
}

.IconIndicator_contactRange-76-90__WUHyV {
  background-color: rgba(255, 87, 34, 0.2);
}

.IconIndicator_contactRange-91-100__KdO\\+U {
  background-color: rgba(244, 67, 54, 0.2);
}

.IconIndicator_reasonMessage__rgF2\\+ {
  display: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 10px;
  word-wrap: break-word;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5px;
  border-radius: 4px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  margin-top: 5px;
  width: 120px;
}`, "",{"version":3,"sources":["webpack://./src/Components/KeepInTouchComponent/IconIndicator.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAGE;EACE,YAAA;AADJ;;AAIA;EACE;IACE,UAAA;IACA,0CAAA;IACA,uBAAA,EAAA,4BAAA;EADF;EAGA;IACE,6CAAA;EADF;EAGA;IACE,yCAAA;IACA,sBAAA,EAAA,uBAAA;EADF;EAIA;IACE,2CAAA;IACA,sBAAA,EAAA,uBAAA;EAFF;EAKA;IACE,YAAA;IACA,yCAAA;IACA,sBAAA,EAAA,uBAAA;EAHF;EAKA;IACE,aAAA;IACA,0CAAA;IACA,qBAAA,EAAA,iCAAA;EAHF;EAKA;IACE,UAAA;IACA,qCAAA;IACA,qBAAA,EAAA,sBAAA;EAHF;AACF;AAQA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,UAAA;EACA,8EAAA;AANF;AAQE;EACE,qBAAA;EACA,eAAA;AANJ;AASE;EACE,cAAA;AAPJ;AAUE;EACE,aAAA;AARJ;AAYE;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAXJ;AAcE;EACE,cAAA;AAZJ;;AAgBA;EACE,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,SAAA;EACA,wBAAA;EACA,UAAA;AAbF;;AAiBA;EAAoB,2CAAA;AAbpB;;AAcA;EAAW,2CAAA;AAVX;;AAWA;EAAW,0CAAA;AAPX;;AAQA;EAAe,2CAAA;AAJf;;AAMA;EACE,kBAAA;EACA,sBAAA;EACA,uBAAA;AAHF;;AAOA;EACE,yBAAA;EACA,0CAAA;EACA,kBAAA;AAJF;AAME;EACE,0CAAA;EACA,2BAAA;AAJJ;;AAQA;EACE,yCAAA;AALF;;AAQA;EACE,yCAAA;AALF;;AAQA;EACE,yCAAA;AALF;;AAQA;EACE,wCAAA;AALF;;AAQA;EACE,wCAAA;AALF;;AAQA;EACE,wCAAA;AALF;;AAQA;EACE,wCAAA;AALF;;AAOA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,YAAA;AAJF","sourcesContent":[".indicatorContainer {\n  position: relative;\n  width: 200px;\n  height: 15px; // default height set to 15px\n  margin: 0 auto;\n  transition: height 0.3s ease;\n\n  &:hover {\n    height: 30px; // height on hover set to 30px\n  }\n\n  &:focus {\n    height: 60px; // height when focused set to 60px\n    outline: none; // optional: removes default focus outline\n  }\n\n  &:focus-within {\n    height: 60px; // height when a child element is focused\n  }\n}\n@keyframes fadeInWiggleAndColor {\n  from {\n    opacity: 0;\n    transform: translateX(1000%) rotate(90deg);\n    filter: grayscale(100%); /* Start in full grayscale */\n  }\n  20% {\n    transform: translateX(-1000%) rotate(-100deg);\n  }\n  40% {\n    transform: translateX(500%) rotate(50deg);\n    filter: grayscale(40%); /* Still in grayscale */\n\n  }\n  60% {\n    transform: translateX(-500%) rotate(-50deg);\n    filter: grayscale(60%); /* Still in grayscale */\n\n  }\n  80% {\n    opacity: 0.8;\n    transform: translateX(200%) rotate(29deg);\n    filter: grayscale(80%); /* Still in grayscale */\n  }\n  95% {\n    opacity: 0.95;\n    transform: translateX(-100%) rotate(-1deg);\n    filter: grayscale(0%); /* Begin shifting to full color */\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0) rotate(0deg);\n    filter: grayscale(0%); /* End in full color */\n  }\n}\n\n\n\n.line {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  border-right: 10px solid;\n  transition: all 0.3s ease;\n  z-index: 9999;\n  opacity: 0; // Start invisible\n  animation: fadeInWiggleAndColor 1.2s ease-in-out forwards;\n\n  &:hover, &:focus {\n    transform: scale(2.1);\n    cursor: pointer;\n  }\n\n  &:hover .reasonMessage {\n    display: block; // Show the reason message on hover\n  }\n\n  div {\n    z-index: 9999; \n\n  }\n\n  span {\n    display: none;\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 2px 5px;\n    // border: 1px solid #ccc;\n    background-color: #fff;\n    border-radius: 4px;\n    white-space: nowrap;\n    font-size: 12px;\n    margin-bottom: 5px;\n  }\n\n  &:hover span, &:focus span {\n    display: block;\n  }\n}\n\n.contactRange {\n  position: absolute;\n  overflow: hidden;\n  top: 0;\n  bottom: 0;\n  background-color: orange;\n  z-index: 1; // Ensure it's behind the lines but above the container\n}\n\n\n.contactTimestamp { border-right-color: rgba(139, 195, 74, 0.7); }\n.minDays { border-right-color: rgba(145, 165, 39, 0.4); }\n.maxDays { border-right-color: rgba(244, 67, 54, 0.6); }\n.presentDays { border-right-color: rgba(255, 235, 59, 0.4); }\n\n.message {\n  text-align: center;\n  vertical-align: middle;\n  justify-content: center;\n\n}\n\n.contactRange {\n  transition: all 0.3s ease;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3); // subtle shadow for depth\n  border-radius: 5px; // rounded corners\n\n  &:hover {\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5); // enhanced shadow on hover\n    transform: translateY(-2px); // slight lift effect on hover\n  }\n}\n\n.contactRange-0-15 {\n  background-color: rgba(139, 195, 74, 0.2); // Light Green with 80% transparency\n}\n\n.contactRange-16-30 {\n  background-color: rgba(205, 220, 57, 0.2); // Lime with 80% transparency\n}\n\n.contactRange-31-45 {\n  background-color: rgba(255, 235, 59, 0.2); // Yellow with 80% transparency\n}\n\n.contactRange-46-60 {\n  background-color: rgba(255, 193, 7, 0.2); // Amber with 80% transparency\n}\n\n.contactRange-61-75 {\n  background-color: rgba(255, 152, 0, 0.2); // Orange with 80% transparency\n}\n\n.contactRange-76-90 {\n  background-color: rgba(255, 87, 34, 0.2); // Deep Orange with 80% transparency\n}\n\n.contactRange-91-100 {\n  background-color: rgba(244, 67, 54, 0.2); // Red with 80% transparency\n}\n.reasonMessage {\n  display: none; // Hide by default\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  font-size: 10px;\n  word-wrap: break-word;\n  background-color: rgba(255, 255, 255, 0.9); // Semi-transparent white background\n  padding: 5px;\n  border-radius: 4px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2); // Subtle shadow for depth\n  margin-top: 5px; // Space between the message and the span\n  width: 120px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"indicatorContainer": `IconIndicator_indicatorContainer__Hx7U0`,
	"line": `IconIndicator_line__s+aIY`,
	"fadeInWiggleAndColor": `IconIndicator_fadeInWiggleAndColor__5jroi`,
	"reasonMessage": `IconIndicator_reasonMessage__rgF2+`,
	"contactRange": `IconIndicator_contactRange__rwVM2`,
	"contactTimestamp": `IconIndicator_contactTimestamp__NRVxo`,
	"minDays": `IconIndicator_minDays__x5l4L`,
	"maxDays": `IconIndicator_maxDays__PEp1Q`,
	"presentDays": `IconIndicator_presentDays__ZFeeP`,
	"message": `IconIndicator_message__69Qxm`,
	"contactRange-0-15": `IconIndicator_contactRange-0-15__ClGrG`,
	"contactRange-16-30": `IconIndicator_contactRange-16-30__wTcDD`,
	"contactRange-31-45": `IconIndicator_contactRange-31-45__oA+ZZ`,
	"contactRange-46-60": `IconIndicator_contactRange-46-60__2QU7t`,
	"contactRange-61-75": `IconIndicator_contactRange-61-75__mHIC5`,
	"contactRange-76-90": `IconIndicator_contactRange-76-90__WUHyV`,
	"contactRange-91-100": `IconIndicator_contactRange-91-100__KdO+U`
};
export default ___CSS_LOADER_EXPORT___;
